import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils.ts";

export type SearchForm = {
  dob: string;
  names: string;
  nir: string;
};

export type SearchTable = {
  id: string;
  birthName?: string;
  usedLastName: string;
  firstRegulatoryFirstName?: string;
  usedFirstName: string;
  dob?: string;
  gender?: string;
  nir?: string;
};

export const searchTableSchema: Schema<SearchTable> = cz.camelCaseObject({
  id: cz.id(),
  birth_name: cz.optional(z.string()),
  used_last_name: z.string(),
  first_regulatory_first_name: cz.optional(z.string()),
  used_first_name: z.string(),
  dob: cz.optional(z.string()),
  gender: cz.optional(z.string()),
  nir: cz.optional(z.string()),
});
